import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from '../../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import { WidgetInput } from "react-addressfinder";
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
 import esim_image from '../../../../../assets/images/addMobilePlan/esim.png';
import physical_image from '../../../../../assets/images/addMobilePlan/physical.png';
import AddPlanHead from './AddPlanHead';
import Loader from "./loader";

const SERVER_URL = process.env.REACT_APP_API_URL+"add_a_wme_mobile_plan/";
const isValidNo = /^[0-9]*$/;



const YourTelsimSim = ({nextStep, prevStep, commonSession, userAccountData, handlePlanDetails}) => {
    const validator = new SimpleReactValidator();
    const [physicalSim,setPhysicalSim]=useState(true)
    const[esim,setEsim]=useState(false)
    const[simType,setSimType]=useState("Physical SIM")


    const handleSimChange=(type)=>{
 
        if(type==="Physical SIM"){
            setPhysicalSim(true)
            setEsim(false)
            setSimType("Physical SIM")
        }else{
            setEsim(true)
            setPhysicalSim(false)
            setSimType("eSIM")
        }
    }
    

    
    const [state, setState] = useState({
        sim_number: '',
        sim_fname: userAccountData.user_firstname,
        sim_lname: userAccountData.user_lastname,
        sim_dob: userAccountData.user_dob,
        sim_address: userAccountData.user_address,
        loading: false
    });


   

    const simCheck = (event) => {
        if (event.target.value.match(isValidNo)) {
            setState((prevState) => ({ ...prevState, sim: event.target.value }));
        }
    };


    const mySubmitHandler = async (event) => {
        event.preventDefault();
        if(simType !== "eSIM" && !state.sim_number){
            swal("", "Please enter the sim number", 'warning');
            return;
        }
        setState((prevState) => ({ ...prevState, loading: true }));

        const post_data = {
            sim_number: state.sim_number,
            SessionId : commonSession,
            sim_type  : simType
        };

        const headers=await getApiHeader();

        try {
            const response = await axios.post(`${SERVER_URL}verify_sim`, post_data, { headers });
            var response_error = true;
            if(response.status===200){
                if(response.data.message !== 'undefined'){
                    //swal(response.data.message, "", 'success');
                    var response_error = false;
                    handlePlanDetails(response.data.data);
                    nextStep();
                }
            }

            setState((prevState) => ({ ...prevState, loading: false }));
            if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }
            //nextStep();
        } catch (error) {
            setState((prevState) => ({ ...prevState, loading: false }));
            console.log(error);
            if(error.response.data.message != 'undefined'){
                swal("", error.response.data.message, 'warning');
            }else{
                swal("Unexpected error", "Please try again", 'error');
            }
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        const numericValue = value.replace(/[^0-9]/g, "");
        setState((prevState) => ({  sim_number: numericValue }));
    };


   
    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <AddPlanHead />
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">
                        {state.loading === true && (
                            <Loader />
                        )}

                        <h6>Your Telsim SIM</h6>
                        <hr/>
                        <br/>

                        <div className="ad-mb-result">

                                 <div className="col-lg-6">
                                    <label className="formbold-form-label formbold-form-label-2">First Name</label>
                                    <input
                                        type="text"
                                        name="text"
                                        placeholder="First Name"
                                        className="formbold-form-input addInput readonly"
                                        value={state.sim_fname}
                                        readOnly
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <label className="formbold-form-label formbold-form-label-2">Last Name</label>
                                    <input
                                        type="text"
                                        name="text"
                                        placeholder="Last Name"
                                        className="formbold-form-input addInput readonly"
                                        value={state.sim_lname}
                                        readOnly
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <label className="formbold-form-label formbold-form-label-2">Date Of Birth</label>
                                    <input
                                        type="text"
                                        name="text"
                                        placeholder="Date Of Birth"
                                        className="formbold-form-input addInput readonly"
                                        value={state.sim_dob}
                                        readOnly
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <label className="formbold-form-label formbold-form-label-2">Current Address</label>
                                    <input
                                        type="text"
                                        name="text"
                                        placeholder="Current Address"
                                        className="formbold-form-input addInput readonly"
                                        value={state.sim_address}
                                        readOnly
                                    />
                                </div>

                        </div>

                        
                        <form onSubmit={mySubmitHandler} className="ad-mb-form choose-sim-block">
                            
                            <div className="col-lg-6 choose-sim">
                                <label className="formbold-form-label formbold-form-label-2">Choose Sim Type</label>
                                <div className="simpik">
                                    <div className="simView simboxstyle" style={{border:simType === 'Physical SIM' && '1px solid #C11D6C'}} onClick={()=> handleSimChange("Physical SIM")}>
                                        <div style={{alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                                            <img src={physical_image} alt="image" style={{width: 40, height: 30}}/>
                                            <label className="col-xl-12 col-lg-12 col-form-label" style={{textAlign: 'center'}}>Physical SIM</label>
                                        </div>
                                    </div>

                                    <div className="esimView simView simboxstyle" style={{border:simType === 'eSIM' && '1px solid #C11D6C'}} onClick={()=> handleSimChange("eSIM")}>
                                        <div style={{alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                                            <img src={esim_image} alt="image" style={{width: 40, height: 30}}/>
                                            <label className="col-xl-12 col-lg-12 col-form-label" style={{textAlign: 'center'}}>eSIM</label>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {simType !== "eSIM" ?

                                <div className="formbold-mb-5 formbold-pt-3 col-lg-6 alignwithsimpik choose-sim">
                                    <label className="formbold-form-label formbold-form-label-2">Enter the SIM number on the Telsim SIM card</label>
                                    <input
                                        type="text"
                                        name="sim_number"
                                        id="sim_number"
                                        maxLength="25"
                                        keyboardType="numeric"
                                        placeholder="Enter the SIM number on the Telsim SIM card"
                                        className="formbold-form-input"
                                        value={state.sim_number}
                                        onChange={handleChange}
                                        // required
                                        autoComplete='off'
                                    />                                    
                                </div>
                                :
                                <div className="formbold-mb-5 formbold-pt-3 col-lg-6 alignwithsimpik choose-sim  esim-selection">
                                    <input
                                        type="text"
                                        name="sim_number"
                                        id="sim_number"
                                        placeholder="Click the Confirm button to continue"
                                        className="formbold-form-input readonly"
                                        value=""
                                        readOnly
                                    />
                                    
                                </div>                           
                            }
                        
                   


                           <br/>
                           <br/>


                        
                            <br/>
                            <div className="button-container add-mb-button-container">


                                <button className="button btn btn-danger" onClick={prevStep}>
                                    Back
                                </button>


                                <button className="button btn btn-danger ad-mb-button">
                                    {simType === "eSIM" ?
                                        <>
                                            Confirm
                                        </>
                                        :
                                        <>
                                            Verify to continue
                                        </>
                                    }
                                </button>
                            </div>


                        </form>



                    </div>

                    
                </div>
            </DashboardLayout>
        </div>
    );
};

export default YourTelsimSim;
